import { services } from '../../../../../constants/services';
import { getAll } from '../../../../../utils/api';
import { RolDto } from '../../../dtos/rol.dto';

export const GetRolesService = async () => {
  const response: any = await getAll<RolDto[]>(`${services.roles}`);
  return response?.data;
};